import { ContactApi, IContactInfo } from '../Api';

export class ContactService {
    api = new ContactApi();

    public updateContact = async (contactViewModel: IContactInfo): Promise<void> => {
        await this.api.updateContact(contactViewModel);
    };
}
